// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenericFooter {
  background-color: var(--genericFooterBG);
  width: 100%;

  padding: var(--spacing-regular);
}

.logotipo-footer {
  width: 119px;
  height: 100px;
  padding: 16px, 8px;
  margin: 0 auto;
  display: block;
}

.Disclaimer-text {
  font-size: var(--font-small);
  font-family: var(--font-family);
  line-height: var(--font-small-line);
  font-weight: 400;
  color: var(--color-neutral-dark);
  text-align: center;
  margin-top: var(--spacing-small);
}

.footer-header.footer-header-desktop {
  padding: 10px 10px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
}

.footer-disclaimer.footer-disclaimer-desktop {
  margin: 100px auto 0;
  width: 100%;
  max-width: 822px;
}

.footer-background {
  background-color: var(--footer-color-background);
}
.footer-divider {
  background-color: var(--color-neutral-light);
}
.footer-typography {
  display: block;
  color: var(--footer-color-button-text);
  text-align: center;
  font-family: var(--font-family);
  font-size: var(--font-small);
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

@media screen and (max-width: 768px) {
  .footer-header {
    flex-direction: column;
    gap: 10px;
  }

  .footer-typography {
    width: 100%;
    font-size: var(--font-small);
    line-height: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericFooter/style.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,WAAW;;EAEX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;EACnB;AACF","sourcesContent":[".GenericFooter {\n  background-color: var(--genericFooterBG);\n  width: 100%;\n\n  padding: var(--spacing-regular);\n}\n\n.logotipo-footer {\n  width: 119px;\n  height: 100px;\n  padding: 16px, 8px;\n  margin: 0 auto;\n  display: block;\n}\n\n.Disclaimer-text {\n  font-size: var(--font-small);\n  font-family: var(--font-family);\n  line-height: var(--font-small-line);\n  font-weight: 400;\n  color: var(--color-neutral-dark);\n  text-align: center;\n  margin-top: var(--spacing-small);\n}\n\n.footer-header.footer-header-desktop {\n  padding: 10px 10px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 56px;\n}\n\n.footer-disclaimer.footer-disclaimer-desktop {\n  margin: 100px auto 0;\n  width: 100%;\n  max-width: 822px;\n}\n\n.footer-background {\n  background-color: var(--footer-color-background);\n}\n.footer-divider {\n  background-color: var(--color-neutral-light);\n}\n.footer-typography {\n  display: block;\n  color: var(--footer-color-button-text);\n  text-align: center;\n  font-family: var(--font-family);\n  font-size: var(--font-small);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n@media screen and (max-width: 768px) {\n  .footer-header {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer-typography {\n    width: 100%;\n    font-size: var(--font-small);\n    line-height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
